import PropTypes from 'prop-types';
import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import {
  tracker,
} from '@unite-us/client-utils';
import IndexDetailView from 'src/components/Dashboard/components/IndexDetailView';
import ExternalCasesIndex from 'src/components/Dashboard/components/Cases/ExternalCasesIndex';
import { fetchDashboardCases } from 'actions/Case/Contact/Group';
import _ from 'lodash';
import DetailView from 'src/components/Dashboard/components/DetailView';
import CaseDetailsView from 'src/components/Cases/components/Detail/CaseDetailsView';
import fetchProvidersUserCore from 'src/actions/UserProvider/fetchProvidersUser';
import { isCaseManagementProvider } from 'common/utils/User/userGroup';
import { isCoordinationCenter } from 'common/utils/Group';
import { getDataOfPage, isDataValid } from 'src/components/Dashboard/utils/dataHelpers';
import callOrLog from 'src/common/utils/callOrLog';
import {
  getCCUserNetwork,
} from 'src/components/User/utils';
import { searchNetworkGroups } from 'actions/Group/Network';
import { goToCase } from 'src/components/Cases/utils/routing';
import { serviceTypesFilter } from 'src/components/Dashboard/utils/filter';
import { DASHBOARD_VIEWS, DASHBOARD_EVENTS } from 'common/utils/EventTracker/utils/eventConstants';
import { isSuperNetwork } from 'src/components/Network/utils';
import subNetworksFilter from 'src/components/Dashboard/utils/subNetworksFilter';
import { useV4toGetOrganizations } from 'src/common/utils/FeatureFlags/flags';
import { loadDashboardSortingConfiguration } from 'src/components/Dashboard/utils/userSortingHandler';
import { browserHistory } from 'common/utils/browserHistory';
import { getSentByOptions } from 'src/components/Groups/Users/utils';
import { createSortChangeHandler } from 'src/components/Dashboard/utils/sortHelpers';
import {
  getInitialDashboardPage,
  refetchCurrentDashboardPage,
  syncDashboardPageFromProps,
} from 'src/components/Dashboard/utils/pageRestore';

export class ExternalCases extends Component {
  constructor(props) {
    super(props);
    this.fetch = this.fetch.bind(this);
    this.fetchAllNetworkGroups = this.fetchAllNetworkGroups.bind(this);
    this.onCellClick = this.onCellClick.bind(this);
    this.onFiltersChange = this.onFiltersChange.bind(this);
    this.onNextClick = this.onNextClick.bind(this);
    this.onPrevClick = this.onPrevClick.bind(this);
    this.shouldFetch = this.shouldFetch.bind(this);
    this.fetchSentByUsers = this.fetchSentByUsers.bind(this);
    this.onSortChange = createSortChangeHandler(this);
    const sortObj = loadDashboardSortingConfiguration(browserHistory.getCurrentLocation().pathname);
    this.state = {
      page: getInitialDashboardPage(props, 'openCases'),
      sidx: sortObj?.column || 'opened_date',
      sord: sortObj?.sortDirection || 'desc',
      filters: {
        service_types: _.get(props, 'filters.service_types', []),
        sent_by: _.get(
          props,
          'filters.sent_by',
          [props.currentEmployee.id],
        ),
      },
      employees: [],
    };
  }

  componentDidMount() {
    this.fetch(this.state.page);
    this.props.fetchProvidersUserCore({
      providers: this.props.groupId,
    })
      .then((response) => {
        if (response) {
          const employees = response.employees;
          this.setState({ employees });
        }
      });

    const { useV4toSearchNetworkGroups } = this.props;
    if (useV4toSearchNetworkGroups && this.props.networkId) {
      this.fetchAllNetworkGroups();
    }

    if (!useV4toSearchNetworkGroups && this.props.networkId && _.isEmpty(this.props.networkGroups)) {
      this.fetchAllNetworkGroups();
    }
  }

  UNSAFE_componentWillReceiveProps(nextProps) {
    syncDashboardPageFromProps(this, nextProps, 'openCases');

    if (!this.props.refetch && nextProps.refetch) {
      refetchCurrentDashboardPage(this, 'openCases', nextProps);
    }
  }

  componentDidUpdate(prevProps) {
    if (this.props.location !== prevProps.location) {
      refetchCurrentDashboardPage(this, 'openCases');
    }
  }

  onCellClick(row) {
    const pagedData = getDataOfPage(this.props.openCases, this.state.page);
    const openCase = pagedData.data[row];

    callOrLog(() => this.context.eventTracker(DASHBOARD_EVENTS.externalCasesRow, {
      view: DASHBOARD_VIEWS.externalCases,
    }, { serviceCase: openCase }));

    goToCase({ ...openCase, pathname: this.props.pathname });
  }

  onFiltersChange(key, activeFilters) {
    const myFilters = { ...this.state.filters, [key]: activeFilters };
    this.setState({
      page: 1,
      filters: myFilters,
    }, () => {
      callOrLog(() => {
        const filters = tracker.buildDashboardFilterPayload(this.state, this.props);
        this.context.eventTracker(DASHBOARD_EVENTS.externalCasesFilter, filters);
      });
      this.fetch();
    });
  }

  onNextClick() {
    const page = this.state.page + 1;
    this.fetch(page);
  }

  onPrevClick() {
    const page = this.state.page - 1;
    this.fetch(page);
  }

  onSortChange = createSortChangeHandler(this);

  fetchAllNetworkGroups(page = 1, search = undefined) {
    const { useV4toSearchNetworkGroups } = this.props;
    return this.props.searchNetworkGroups(
      this.props.networkId,
      {},
      { page, search },
      useV4toSearchNetworkGroups,
    ).then((response) => {
      if (useV4toSearchNetworkGroups) {
        const dropdownResponse = response.map((provider) => ({
          label: provider.name,
          value: provider.id,
          initial: false,
        }));
        return dropdownResponse;
      }
      if (!useV4toSearchNetworkGroups) {
        const nextPage = _.get(response, 'data.paging.next_page');
        if (nextPage) {
          this.fetchAllNetworkGroups(nextPage);
        }
      }
      return true;
    });
  }

  shouldFetch(page) {
    if (isDataValid(this.props.openCases, page)) {
      this.setState({ page });
    } else {
      this.fetch(page);
    }
  }

  fetch(page = 1) {
    const formattedFilters = _.reduce(
      this.state.filters,
      (acc, f, key) => {
        if (f === 'all') {
          return acc;
        }
        return _.merge(acc, { [key]: f });
      },
      {},
    );
    formattedFilters.sent_by = _.uniq(
      _.map(formattedFilters.sent_by, (f) => f.split('-employee')[0]),
    );
    if (this.props.isCC) {
      formattedFilters.networks = [this.props.networkId];
    }

    this.setState({ page }, () => {
      this.props.fetchDashboardCases(
        this.props.groupId,
        {
          target: 'externalCases',
          sidx: this.state.sidx,
          sord: this.state.sord,
          filters: formattedFilters,
          page,
        },
        false,
      );
    });
  }

  fetchSentByUsers(search = '') {
    const { groupId, currentEmployee } = this.props;
    return this.props.fetchProvidersUserCore({
      providers: groupId,
      options: {
        licensed: false,
        text: search,
      },
    })
      .then((response) => {
        if (response) {
          return getSentByOptions(
            response.employees,
            this.state,
            currentEmployee,
          );
        }

        return [];
      });
  }

  render() {
    const {
      currentEmployee,
      currentGroup,
      groupId,
      isCaseMgmtProvider,
      isCC,
      isFetching,
      location,
      openCases,
      params,
      serviceTypes,
    } = this.props;
    const { employees } = this.state;
    let filters = [
      serviceTypesFilter(serviceTypes, this.state.filters.service_types),
      {
        key: 'sent_by',
        name: 'Sent By',
        pluralName: 'Sent By',
        options: getSentByOptions(employees, this.state, currentEmployee),
        asyncSearch: this.fetchSentByUsers,
      },
      subNetworksFilter(currentGroup, this.state.filters.networks),
    ];

    filters = _.compact(filters);

    const innerContentView = (
      <CaseDetailsView
        params={params}
        history={location.state}
        type="externalCases"
        showContactColumn
        subjectType="case"
      />
    );

    const openCasesDetailView = (
      <DetailView
        innerContentView={innerContentView}
      />
    );
    const pagedData = getDataOfPage(openCases, this.state.page);

    return (
      <IndexDetailView
        params={this.props.params}
        DetailView={openCasesDetailView}
        IndexView={ExternalCasesIndex}
        data={pagedData.data}
        paging={pagedData.paging}
        isFetching={isFetching || pagedData.invalidated}
        onNextClick={this.onNextClick}
        onPrevClick={this.onPrevClick}
        onCellClick={this.onCellClick}
        sortConfig={this.onSortChange}
        setSort={{ sidx: this.state.sidx, sord: this.state.sord }}
        initialSort={{ [this.state.sidx]: this.state.sord }}
        isCC={isCC}
        isSuperNetwork={isSuperNetwork(currentGroup.networks, groupId)}
        onFiltersChange={this.onFiltersChange}
        filters={_.sortBy(filters, 'name')}
        isCaseMgmtProvider={isCaseMgmtProvider}
        fetchGroupsUsers={this.fetchSentByUsers}
      />
    );
  }
}

ExternalCases.defaultProps = {
  location: { state: {} },
  networkId: undefined,
};

ExternalCases.propTypes = {
  currentEmployee: PropTypes.object.isRequired,
  currentGroup: PropTypes.object.isRequired,
  fetchDashboardCases: PropTypes.func.isRequired,
  groupId: PropTypes.string.isRequired,
  isCaseMgmtProvider: PropTypes.bool.isRequired,
  isCC: PropTypes.bool.isRequired,
  isFetching: PropTypes.bool.isRequired,
  location: PropTypes.object,
  networkGroups: PropTypes.object.isRequired,
  networkId: PropTypes.string,
  openCases: PropTypes.shape({
    data: PropTypes.array.isRequired,
    currentPage: PropTypes.number.isRequired,
  }).isRequired,
  params: PropTypes.object.isRequired,
  pathname: PropTypes.string.isRequired,
  refetch: PropTypes.bool.isRequired,
  searchNetworkGroups: PropTypes.func.isRequired,
  serviceTypes: PropTypes.array.isRequired,
  useV4toSearchNetworkGroups: PropTypes.func.isRequired,
  fetchProvidersUserCore: PropTypes.func.isRequired,
};

function mapStateToProps(state, ownProps) {
  const user = _.wget(state, 'user', {});
  const groupId = _.get(state, 'session.groupId');
  const userGroups = _.get(state, 'groups.data');
  const network = getCCUserNetwork(user, groupId);
  const currentGroup = _.find(userGroups, { id: groupId }) || {};

  return {
    currentEmployee: _.wget(state, 'globalState.currentEmployee', {}),
    currentGroup,
    filters: _.get(state, 'dashboard.externalCases.filters', {}),
    groupId,
    isCaseMgmtProvider: isCaseManagementProvider(state),
    // CORE-WORK - Need to resolve user.groups migration work
    isCC: isCoordinationCenter(_.get(currentGroup, 'networks', []), groupId),
    isFetching: _.get(state, 'dashboard.externalCases.isFetching', false),
    networkGroups: _.get(state, 'networks.groups', {}),
    networkId: _.get(network, 'id', null),
    openCases: _.get(state, 'dashboard.externalCases', {}),
    refetch: _.get(state, 'dashboard.refetch'),
    serviceTypes: _.wget(state, 'serviceTypes.allNetworksAndPrograms', []),
    token: _.get(state, 'session.token', ''),
    user,
    userId: _.wget(user, 'id', ''),
    useV4toSearchNetworkGroups: useV4toGetOrganizations(state),
    pathname: _.wget(ownProps, 'location.pathname', ''),
  };
}

function mapDispatchToProps(dispatch) {
  return {
    ...bindActionCreators({
      fetchDashboardCases,
      searchNetworkGroups,
      fetchProvidersUserCore,
    }, dispatch),
    dispatch,
  };
}

ExternalCases.contextTypes = {
  eventTracker: PropTypes.func.isRequired,
};

export default connect(
  mapStateToProps,
  mapDispatchToProps,
)(ExternalCases);
